import { LOGIN_SUCCEEDED } from '../actions/actionTypes'

const loginReducer = (ResultLogin = [], actions) => {
    switch (actions.type) {
        case LOGIN_SUCCEEDED:
            if(Object.keys(actions.resultLogin).length > 0)
            {        
                return {...ResultLogin,ResultLogin: true};
            }
            else
            {
                return {...ResultLogin,ResultLogin: false};
            }
        // case LOGIN_FAILED:
        //     ResultLogin = false;
        //     return ResultLogin;
        default:
            return {...ResultLogin,ResultLogin: false};
    }
}

export default loginReducer;